import learningRequestList, {
  LearningRequestsListParams
} from "@/getinfo-api/learning-requests";
import api from "@/getinfo-api";
import { MainList } from "@/classes/MainList";
import { Course as ICourse } from "@/api/models/course";

export class OrdersListClass extends MainList {
  params: LearningRequestsListParams = {
    limit: 30,
    offset: 0
  };

  constructor(params?: any, selectedValue?: string | undefined) {
    super();
    this.method = learningRequestList;
    this.params = { ...this.params, ...params };
    this.baseParams = this.params;
    this.dataLabel = "requests";
    if (selectedValue) {
      this.singleMethod = () => api.CourseApi.get(selectedValue);
      this.single();
    }
    this.list();
  }

  search(value: string) {
    this.params.number = value;
    this.params.offset = 0;
    this.listItems = [];
    this.list();
  }

  get orders(): Array<ICourse> {
    return this.listItems;
  }
}
